import React from 'react';
import { usePageMeta } from '../components/Layout';
import { Reveal, MarianaEmbed } from '../components/Shared';

export default function Book() {
  usePageMeta(
    'Book Your First HIIT Class — Dallas',
    'Book your first HIIT class at PITFIT in Uptown Dallas — $15 for new clients. No membership, no commitment. Pick a class time and just show up.'
  );

  return (
    <section className="section-pad">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="mono-label mb-4">$15 First Class</p>
          <h1 className="h-display !text-[clamp(2.2rem,4.5vw,3.4rem)] text-white">Claim your first class.</h1>
          <p className="text-muted-pf mt-5 text-[17px] leading-relaxed max-w-2xl">
            Reserve instantly on the live board below — real times, real spots, checkout included. Your first class is just $15 for new clients, no membership required.
          </p>
        </Reveal>
        <Reveal delay={100}>
          <div className="mt-8">
            <MarianaEmbed testId="mariana-book" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
